
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4';

const logindaysdata = async (params) => {
  const response = await fetch(`${process.env.REACT_APP_URL_FPS}/api/logindays`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });

  if (!response.ok) throw new Error('Failed to fetch data');

  return response.json();
};
const handleDownload = () => {
  const tableSelect = document.getElementById("distReport");
  if (!tableSelect) return;

  const tableClone = tableSelect.cloneNode(true);

  const allHeaders = tableClone.querySelectorAll("th");
  allHeaders.forEach(h => {
    h.style.backgroundColor = "#FFA500"; // Orange
    h.style.color = "#000";
  });

  //  ORANGE color for TOTAL ROW (last <tr> of <tbody>)
  const tbody = tableClone.querySelector("tbody");
  if (tbody) {
    const totalRow = tbody.lastElementChild; // LAST <tr>
    if (totalRow) {
      totalRow.querySelectorAll("td").forEach(td => {
        td.style.backgroundColor = "#FFA500"; // Orange
        td.style.color = "#000";
        td.style.fontWeight = "bold";
      });
    }
  }

  // Build HTML content for Excel
  const htmlContent = `
    <html>
      <head>
        <meta charset="UTF-8" />
        <style>
          table, th, td {
            border: 1px solid #000;
            border-collapse: collapse;
          }
          th, td {
            padding: 5px;
          }
        </style>
      </head>
      <body>
        ${tableClone.outerHTML}
      </body>
    </html>
  `;

  const blob = new Blob([htmlContent], { type: "application/vnd.ms-excel" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = "loginDaysNo.xls";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};




const NoofLoginInterfaxe = ({ dist_code, afso_code, month, year }) => {
  const [reportData, setReportData] = useState([]);
  const [schemelist, setSchemelist] = useState([]);
  const [comidityList, setcomidityList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const fpscardstab = useRef(null);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [userRole, setUserRole] = useState(null);

  const navigate = useNavigate();


  const [totals, setTotals] = useState({
    daysOpen: 0,
    drawnCards: [],
    totalCards: [],
    totalUnits: [],
    totalDrawn: 0,
    totalAvail: 0,
    commoditySales: []
  });

  const calculateTotals = (data, schemes, commodities) => {
    if (!data || data.length === 0) return;

    let daysOpenTotal = 0;
    const drawnCardsTotal = new Array(schemes.length).fill(0);
    const totalCardsTotal = new Array(schemes.length).fill(0);
    const totalUnitsTotal = new Array(schemes.length).fill(0);

    let totalDrawnSum = 0;
    let totalAvailSum = 0;

    const commoditySalesTotal = schemes.map(() =>
      new Array(commodities.length).fill(0)
    );

    data.forEach(item => {
      daysOpenTotal += parseFloat(item.no_of_days_open) || 0;

      item.schemelist?.forEach((sch, idx) => {
        drawnCardsTotal[idx] += parseFloat(sch.drawn_cards) || 0;
        totalCardsTotal[idx] += parseFloat(sch.total_cards) || 0;
        totalUnitsTotal[idx] += parseFloat(sch.total_units) || 0;
      });

      totalDrawnSum += parseFloat(item.total_drawnCards) || 0;
      totalAvailSum += parseFloat(item.total_Cards) || 0;

      item.schemelist?.forEach((sch, sIdx) => {
        commodities.forEach((comm, cIdx) => {
          const sale = item.comidityList?.find(
            x => x.scheme_id === sch.scheme_id && x.comm_id === comm.comm_id
          );
          commoditySalesTotal[sIdx][cIdx] += parseFloat(sale?.saleQty) || 0;
        });
      });
    });

    setTotals({
      daysOpen: daysOpenTotal,
      drawnCards: drawnCardsTotal,
      totalCards: totalCardsTotal,
      totalUnits: totalUnitsTotal,
      totalDrawn: totalDrawnSum,
      totalAvail: totalAvailSum,
      commoditySales: commoditySalesTotal,
    });
  };


  const getCurrentDateTime = () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };


  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}/api/session-info`, { withCredentials: true })
      .then((res) => {
        setUserRole(res.data.userRole);
        // if (res.data.userRole <= 0) navigate("/login");
      })
      .catch(() => {
        setSessionExpired(true);
      });
  }, [navigate]);

  useEffect(() => {
    const getData = async () => {
      try {
        const response_data = await logindaysdata({
          month,
          year,
          dist_code,
          afso_code
        });

        setTabHeading(response_data.heading);

        if (response_data.data && response_data.data.length > 0) {
          setReportData(response_data.data);

          const uniques = response_data.data.reduce((acc, item) => {
            item.schemelist?.forEach(sch => {
              if (!acc.some(a => a.scheme_id === sch.scheme_id)) acc.push(sch);
            });
            return acc;
          }, []);

          const commdities = response_data.data.reduce((com, item) => {
            item.comidityList?.forEach(com1 => {
              if (!com.some(b => b.comm_id === com1.comm_id)) com.push(com1);
            });
            return com;
          }, []);

          setSchemelist(uniques);
          setcomidityList(commdities);

          calculateTotals(response_data.data, uniques, commdities);
        } else {
          setReportData([]);
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [dist_code, afso_code, month, year]);

  const handleChangePage = (e, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && fpscardstab.current) {
      fpscardstab.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [loading, error, reportData]);

  if (loading)
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );

  if (error) return <div className="mainhead" align="center">Internal Error</div>;

  if (reportData.length === 0)
    return <div className="mainhead" align="center">No data found</div>;

  const paginatedData =
    rowsPerPage === 'all'
      ? reportData
      : reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>

      <div style={{ display: 'flex', justifyContent: 'right', width: '95%' }}>
        <PaginationTable
          count={reportData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>

      <div style={{
        overflowX: 'auto',
        overflowY: 'auto',
        maxHeight: '700px',
        maxWidth: '100%',
        margin: '0 auto'
      }}>

        <table
          ref={fpscardstab}
          align="center"
          width="90%"
          border="1"
          cellPadding="6"
          id="distReport"
          style={{ minWidth: '100%', width: '100%' }}
        >

          <thead style={{
            position: 'sticky',
            top: 0,
            background: '#fff',
            zIndex: 100,
          }}>
            <tr className="tableheader">
              <th colSpan={((schemelist.length) * 2) + 14 + (schemelist.length * comidityList.length)}>
                {tabHeading}
              </th>
            </tr>

            <tr className="tableheader">
              <th rowSpan={3}>Sl No</th>
              <th rowSpan={3}>District</th>
              <th rowSpan={3}>office</th>
              <th rowSpan={3}>FPS Id</th>
              <th rowSpan={3}>First Login Date</th>
              <th rowSpan={3}>Last Login Date</th>
              <th rowSpan={3}>No of Days Open</th>
              <th colSpan={(schemelist.length * 2) + 1}>scheme wise cards</th>
              <th colSpan={schemelist.length + 1}>scheme wise drawn cards</th>
              <th rowSpan={3}>% of distribution <br></br>(Tot Drawn cards/Tot cards)</th>

              {schemelist.map((sch, idx) => (
                <th key={idx} colSpan={comidityList.length}>{sch.scheme_short_name}</th>
              ))}
            </tr>

            <tr className="tableheader">
              {schemelist.map((sch, idx) => <th key={idx} colSpan={2}>{sch.scheme_short_name}</th>)}
              <th rowSpan={2} >Total cards</th>

              {schemelist.map((sch, idx) => <th key={idx} rowSpan={2}  >{sch.scheme_short_name}</th>)}
              <th rowSpan={2} >Total</th>

              {schemelist.map((sch, sIdx) =>
                comidityList.map((comm, cIdx) => (
                  <th key={`${sIdx}-${cIdx}`} rowSpan={2}  >{comm.comm_name_en}</th>
                ))
              )}
            </tr>

            <tr className="tableheader">
              {schemelist.map((scheme, index) => (
                <React.Fragment key={`cardunit-${index}`}>
                  <th>Cards</th>
                  <th>Units</th>
                </React.Fragment>
              ))}
            </tr>
          </thead>

          <tbody>
            {paginatedData.map((item, index) => (
              <tr key={index}>
                <td>{rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}</td>
                <td>{item.dist_name}</td>
                <td>{item.afso_name}</td>
                <td>{item.fps_id}</td>

                <td>{item.first_login_date ? item.first_login_date.substring(0, 19) : "--NA--"}</td>
                <td>{item.last_login_date ? item.last_login_date.substring(0, 19) : "--NA--"}</td>

                <td style={{ textAlign: 'right' }}>{item.no_of_days_open}</td>

                {/* Cards and Units columns */}
                {item.schemelist?.map((sch, idx) => (
                  <React.Fragment key={`card-unit-${idx}`}>
                    <td style={{ textAlign: 'right' }}>{sch.total_cards}</td>
                    <td style={{ textAlign: 'right' }}>{sch.total_units || '0'}</td>
                  </React.Fragment>
                ))}
                <td style={{ textAlign: 'right' }}>{item.total_Cards}</td>

                {/* Drawn cards */}
                {item.schemelist?.map((sch, idx) => (
                  <td key={idx} style={{ textAlign: 'right' }}>{sch.drawn_cards}</td>
                ))}
                <td style={{ textAlign: 'right' }}>{item.total_drawnCards}</td>

                {/* Percentage */}
                <td style={{ textAlign: 'right' }}>
                  {item.total_Cards > 0
                    ? ((item.total_drawnCards / item.total_Cards) * 100).toFixed(2)
                    : '0.00'}
                </td>

                {/* Commodity sales */}
                {item.schemelist?.map((sch, sIdx) =>
                  comidityList.map((comm, cIdx) => {
                    const sale = item.comidityList?.find(
                      (x) => x.scheme_id === sch.scheme_id && x.comm_id === comm.comm_id
                    );
                    return (
                      <td key={`${sIdx}-${cIdx}`} style={{ textAlign: 'right' }}>
                        {sale?.saleQty ? sale.saleQty : "0.00"}
                      </td>
                    );
                  })
                )}
              </tr>
            ))}

            {/* TOTAL ROW */}
            <tr className="tableheader"
style={{
    position: 'sticky',
    bottom: 0,
    background: '#FFA500',
    zIndex: 200,
    fontWeight: 'bold'
  }}>
              <td colSpan={6} style={{ textAlign: 'right' }}>Total:</td>
              <td style={{ textAlign: 'right' }}>{totals.daysOpen}</td>

              {/* Cards and Units totals */}
              {totals.totalCards.map((total, idx) => (
                <React.Fragment key={`total-card-unit-${idx}`}>
                  <td style={{ textAlign: 'right' }}>{total.toFixed(2)}</td>
                  <td style={{ textAlign: 'right' }}>{totals.totalUnits[idx].toFixed(2)}</td>
                </React.Fragment>
              ))}
              <td style={{ textAlign: 'right' }}>{totals.totalCards.reduce((a, b) => a + b, 0).toFixed(2)}</td>

              {/* Drawn cards totals */}
              {totals.drawnCards.map((total, idx) => (
                <td key={idx} style={{ textAlign: 'right' }}>{total.toFixed(2)}</td>
              ))}
              <td style={{ textAlign: 'right' }}>{totals.totalDrawn.toFixed(2)}</td>

              {/* Percentage total */}
              <td style={{ textAlign: 'right' }}>
                {totals.totalCards.reduce((a, b) => a + b, 0) > 0
                  ? ((totals.totalDrawn / totals.totalCards.reduce((a, b) => a + b, 0)) * 100).toFixed(2)
                  : '0.00'}
              </td>

              {/* Commodity sales totals */}
              {totals.commoditySales.map((schemeArr, sIdx) =>
                schemeArr.map((total, cIdx) => (
                  <td key={`${sIdx}-${cIdx}`} style={{ textAlign: 'right' }}>
                    {total.toFixed(2)}
                  </td>
                ))
              )}
            </tr>
          </tbody>
        </table>



      </div>
      <br></br>
      {userRole != null && userRole > 0 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <button
            type="button"
            className="button button2"
            onClick={handleDownload}
          >
            Data to Excel
          </button>
        </div>

      )}

      <br /><br /><br />
    </>
  );
};

export default NoofLoginInterfaxe;